import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { articles, getArticlesByCategory } from "@/mocks/articles";
import { getCategory } from "@/mocks/categories";
import { formatHeat } from "@/utils/format";

export default function AnnualSection() {
  const category = getCategory("niandu");
  const annual = getArticlesByCategory("niandu")[0];
  const topHeat = [...articles].sort((a, b) => b.heat - a.heat).slice(0, 5);

  return (
    <section className="mx-auto max-w-[1400px] px-4 py-16 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="YEAR IN REVIEW"
        title="年度大瓜回顾"
        description="把这一年真正刷屏过的事件按热度排一遍，哪场反转最多、哪场后续最离谱，一次补完。"
        linkTo="/category/niandu"
        linkLabel="查看年度盘点"
      />

      <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-10">
        <div className="lg:col-span-5">
          {annual && (
            <Link
              to={`/article/${annual.id}`}
              className="group relative flex h-full min-h-[320px] flex-col justify-end overflow-hidden rounded-lg bg-foreground-950 p-6 cursor-pointer"
            >
              <img
                src={category?.image ?? annual.cover}
                alt={category?.imageAlt ?? annual.coverAlt}
                className="absolute inset-0 h-full w-full object-cover object-top opacity-80 transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 via-foreground-950/60 to-transparent" />
              <div className="relative z-10">
                <span className="mb-3 inline-flex rounded-full bg-accent-500 px-3 py-1 text-[11px] font-semibold tracking-wide text-foreground-950">
                  年度编辑部精选
                </span>
                <h3 className="mb-2 font-heading text-xl font-bold leading-snug text-background-50 md:text-2xl">
                  {annual.title}
                </h3>
                <p className="line-clamp-2 text-sm text-background-200">{annual.summary}</p>
              </div>
            </Link>
          )}
        </div>

        <div className="lg:col-span-7">
          <ol className="divide-y divide-background-200 border-y border-background-200">
            {topHeat.map((article, index) => (
              <li key={article.id}>
                <Link
                  to={`/article/${article.id}`}
                  className="group flex items-center gap-4 py-4 transition-colors cursor-pointer"
                >
                  <span
                    className={`font-heading text-3xl font-black leading-none md:text-4xl ${
                      index === 0 ? "text-primary-500" : "text-background-300"
                    }`}
                  >
                    {String(index + 1).padStart(2, "0")}
                  </span>
                  <span className="min-w-0 flex-1">
                    <h3 className="line-clamp-2 text-sm font-semibold text-foreground-900 transition-colors group-hover:text-primary-600 md:text-base">
                      {article.title}
                    </h3>
                    <span className="mt-1.5 flex flex-wrap items-center gap-x-3 text-xs text-foreground-500">
                      <span>{article.publishedAt}</span>
                      <span className="flex items-center gap-1">
                        <i className="ri-fire-line text-primary-500" />
                        {formatHeat(article.heat)} 热度
                      </span>
                    </span>
                  </span>
                  <span className="hidden h-10 w-16 shrink-0 overflow-hidden rounded-md bg-background-100 sm:block">
                    <img
                      src={article.cover}
                      alt={article.coverAlt}
                      className="h-full w-full object-cover object-top"
                    />
                  </span>
                </Link>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}